import { CURRENCIES, currencyTextValue, dateFormat, formatDate, i18, trb } from '../../Utilities';

interface IProps {
  data: {
    FileUploadDate: string;
    FileName: string;
    FileHeaderId: string;
    PaymentsCount: number;
    PaymentValue: number;
  };
}

export const SummaryUnsignedPaymentFiles = ({ data }: IProps) => {
  return (
    <>
      <h3 className="eb_content_subtitle">{trb(i18.Labels.Summary)}</h3>
      <div className="eb_table mb-3 w-100">
        <div className="row eb_table_row">
          <div className="col-12 col-sm-12 col-md-6 col-xl-4">
            <div className="text-black-50">{trb(i18.Labels.UploadDateTime)}</div>
            <div className="eb_fw_600">{formatDate(data?.FileUploadDate, dateFormat().dateTimeSecond)}</div>
          </div>
          <div className="col-12 col-sm-12 col-md-6 col-xl-4">
            <div className="text-black-50">{trb(i18.Labels.FileName)}</div>
            <div
              style={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              }}
              className="eb_fw_600"
            >
              {data?.FileName}
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-6 col-xl-4">
            <div className="text-black-50">{trb(i18.Labels.FileId)}</div>
            <div
              style={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              }}
              className="eb_fw_600"
            >
              {data?.FileHeaderId}
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-6 col-xl-4">
            <div className="text-black-50">{trb(i18.Labels.PaymentCount)}</div>
            <div className="eb_fw_600">{data?.PaymentsCount}</div>
          </div>
          <div className="col-12 col-sm-12 col-md-6 col-xl-8">
            <div className="text-black-50">{trb(i18.Labels.PaymentSum)}</div>
            <div className="eb_fw_600">{currencyTextValue(data?.PaymentValue, CURRENCIES.EUR)}</div>
          </div>
        </div>
      </div>
    </>
  );
};
